// Canvas state — agents (loaded from the API), pan/zoom transform,
// search filter, focused-node id (for the modal).

import { createStore } from "./store"
import { api } from "../lib/api"

// Default view centered so the auto-laid-out grid is visible
// without hiding the master node behind the top-left legend.
const DEFAULT_VIEW = { scale: 0.78, tx: -80, ty: 0 }

export const canvasStore = createStore({
  agents: [],            // [{ id, role, name, status, x, y, ... }]
  loading: false,
  loadError: null,
  view: { ...DEFAULT_VIEW },
  search: "",
  focusedAgentId: null,
})

export async function loadAgents(paths) {
  canvasStore.setState({ loading: true, loadError: null })
  try {
    const { agents } = await api.get(paths.agents)
    // Auto-position agents that don't have a saved position yet —
    // simple grid layout so the user can drag them around.
    const positioned = autoLayout(agents)
    canvasStore.setState({ agents: positioned, loading: false })
  } catch (e) {
    canvasStore.setState({ loadError: e.message, loading: false })
  }
}

function autoLayout(agents) {
  // Master agents (manager_id == null AND have reports) anchor the top
  // row; everything else flows underneath. Keeps initial layout
  // intuitive without dragging.
  const cols = 3
  const startX = 700, startY = 200
  const gapX = 290, gapY = 280
  return agents.map((a, i) => {
    if (a.x != null && a.y != null) return a
    const col = i % cols, row = Math.floor(i / cols)
    return { ...a, x: startX + col * gapX, y: startY + row * gapY }
  })
}

export function updateAgentPosition(agentId, x, y) {
  canvasStore.setState((s) => ({
    ...s,
    agents: s.agents.map((a) => (a.id === agentId ? { ...a, x, y } : a)),
  }))
}

export async function persistAgentPosition(agentId, x, y, paths) {
  return api.put(`${paths.canvas_positions}/${agentId}`, { position: { x: Math.round(x), y: Math.round(y) } })
}

export function setView(view)     { canvasStore.setState({ view }) }
export function resetView()       { canvasStore.setState({ view: { ...DEFAULT_VIEW } }) }
export function zoomBy(factor) {
  const v = canvasStore.getState().view
  const scale = Math.min(1.6, Math.max(0.4, v.scale * factor))
  canvasStore.setState({ view: { ...v, scale } })
}
export function setSearch(q)      { canvasStore.setState({ search: q }) }
export function focusAgent(id)    { canvasStore.setState({ focusedAgentId: id }) }
export function closeAgent()      { canvasStore.setState({ focusedAgentId: null }) }
